import api from '@/common/axios'

export const fetchPageMeta = () => api.get('/lsa/ajax/page_meta')
